// extracted by mini-css-extract-plugin
export default {"button":"ShowMoreButton_button__QdTRV","text":"ShowMoreButton_text__SFyDk","button__up":"ShowMoreButton_button__up__XXvPY","arrow":"ShowMoreButton_arrow__ywFhJ"};